import React, { useEffect } from "react";

function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="container upy-10 upx-5 text-black"
      style={{
        minHeight: "80vh",
        maxWidth: "800px",
        margin: "0 auto",
        paddingTop: "100px",
      }}
    >
      <h1 className="fw-bold mb-4">Privacy Policy for Raycura</h1>
      <p className="text-secondary mb-5">
        <strong>Last Updated:</strong> September 21, 2026
      </p>

      <p className="ufs-4">
        Raycura Medical Technologies is committed to protecting your privacy.
        This Privacy Policy explains how we collect, use, disclose, and
        safeguard your information when you use our mobile application and our
        associated hardware devices (Better and GoNeo).
      </p>

      <h3 className="fw-bold mt-5 mb-3">1. Information We Collect</h3>

      <h5 className="fw-bold mt-4">
        A. Personal Information (Doctors & Clinics)
      </h5>
      <p className="ufs-4">
        When a doctor or clinic registers on our platform, we collect basic
        profile information, including:
      </p>
      <ul className="ufs-4">
        <li>Name and contact information (Email, Phone Number)</li>
        <li>Basic clinic details (Clinic Name)</li>
      </ul>

      <h5 className="fw-bold mt-4">B. Health & Patient Data</h5>
      <p className="ufs-4">
        To provide our physiotherapy and orthopedic assessment services, doctors
        may input patient data into the App, including:
      </p>
      <ul className="ufs-4">
        <li>Patient demographics (Name, Age, Gender)</li>
        <li>Medical history and physical assessment records</li>
        <li>
          Real-time joint movement data (Range of Motion, angles, etc.) captured
          via our Bluetooth hardware devices.
        </li>
      </ul>

      <h5 className="fw-bold mt-4">C. Device Permissions</h5>
      <ul className="ufs-4">
        <li>
          <strong>Bluetooth:</strong> The App requires Bluetooth access to
          connect with, configure, and receive real-time assessment data from
          our hardware devices (Better and GoNeo). We do not use Bluetooth for
          location tracking.
        </li>
      </ul>

      <h3 className="fw-bold mt-5 mb-3">2. How We Use Your Information</h3>
      <p className="ufs-4">
        We use the collected information for the following purposes:
      </p>
      <ul className="ufs-4">
        <li>To create and manage doctor/clinic accounts.</li>
        <li>To pair with and receive data from Raycura hardware devices.</li>
        <li>
          To generate accurate patient assessment reports (e.g., Range of Motion
          progress).
        </li>
        <li>
          To store historical data securely in our cloud database so doctors can
          track patient recovery over time.
        </li>
        <li>
          To improve our app functionality, hardware firmware, and overall user
          experience.
        </li>
      </ul>

      <h3 className="fw-bold mt-5 mb-3">
        3. How We Store and Protect Your Data
      </h3>
      <p className="ufs-4">
        All data, including sensitive health information, is transmitted
        securely and stored in our encrypted database (MongoDB). We implement
        industry-standard security measures to prevent unauthorized access,
        alteration, disclosure, or destruction of your personal and medical
        information.
      </p>

      <h3 className="fw-bold mt-5 mb-3">4. Data Sharing and Disclosure</h3>
      <p className="ufs-4">
        We do not sell, trade, or rent your personal or health information to
        third parties. We may disclose information only in the following
        scenarios:
      </p>
      <ul className="ufs-4">
        <li>
          <strong>To the Treating Doctor:</strong> Patient data is exclusively
          accessible by the doctor or clinic that created the patient profile.
        </li>
        <li>
          <strong>Legal Requirements:</strong> If required by law, subpoena, or
          other legal processes.
        </li>
      </ul>

      <h3 className="fw-bold mt-5 mb-3">5. Your Rights and Data Deletion</h3>
      <p className="ufs-4">
        Users (Doctors/Clinics) have the right to access, update, or request the
        deletion of their account and associated patient data. If you wish to
        delete your data or your patients' data from our servers, please contact
        us at the email provided below.
      </p>

      <h3 className="fw-bold mt-5 mb-3">6. Changes to This Privacy Policy</h3>
      <p className="ufs-4">
        We may update our Privacy Policy from time to time. We will notify you
        of any changes by posting the new Privacy Policy on this page and
        updating the "Last Updated" date.
      </p>

      <h3 className="fw-bold mt-5 mb-3">7. Contact Us</h3>
      <p className="ufs-4">
        If you have any questions or concerns about this Privacy Policy or our
        data practices, please contact us at:
      </p>
      <ul className="ufs-4 pb-5">
        <li>
          <strong>Email:</strong> mail@raycura.com
        </li>
        <li>
          <strong>Phone:</strong> +91 7028264636
        </li>
        <li>
          <strong>Address:</strong> Renuka apartment, Plot no 79/80 Flat no 202,
          Swavalambi Nagar, Nagpur, Maharashtra 440022
        </li>
      </ul>
    </div>
  );
}

export default PrivacyPolicy;
